"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focus = void 0;
var focus = exports.focus = function focus(ref) {
  var _ref$current;
  var focusOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return ref === null || ref === void 0 || (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus(focusOptions);
};
//# sourceMappingURL=refs.js.map